export default __webpack_public_path__ + "static/media/rabby_logo.477a4097.svg";